import { useGraphQLQuery } from '@betterment/graphql';

import { ChatbotEligibilityDocument } from './graphql/query.chatbotEligibility.generated';

import { useIsAuthenticated } from '../features/authentication/authentication';
import { isMobileWebview } from '../Shared/user-agent-helpers';

export function useZendeskChatbotConfig(): boolean {
  const isAuthenticated = useIsAuthenticated();
  const { data, loading } = useGraphQLQuery(ChatbotEligibilityDocument, {
    skip: !isAuthenticated,
    fetchPolicy: 'cache-first',
    throwOnError: false,
  });

  const isInstitutionallyAdvised = data?.advisor?.__typename === 'InstitutionalAdvisor';
  const isMobileWebviewUser = isMobileWebview();

  return !loading && !isMobileWebviewUser && isAuthenticated && !isInstitutionallyAdvised;
}
